import { render, staticRenderFns } from "./closed-question.vue?vue&type=template&id=196a3df8&scoped=true"
import script from "./closed-question.vue?vue&type=script&lang=js"
export * from "./closed-question.vue?vue&type=script&lang=js"
import style0 from "./closed-question.vue?vue&type=style&index=0&id=196a3df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a3df8",
  null
  
)

export default component.exports